const initialState = {
  PREV_VIEW: null,
  CURRENT_VIEW: null,
  globalLoaderState: false,
  language: 1,
  browserIncompatible: false,
};

export default initialState;
